/**
 * 段落处理工具
 * 提供文本分段和段落查找功能
 *
 * 核心功能：
 * 1. 文本分段为段落结构
 * 2. 在段落中查找指定文本
 */
/**
 * 将原始文本分割成段落数组
 * @param rawText 原始文本
 * @returns 段落数组
 */
export function splitIntoParagraphs(rawText) {
    if (!rawText || typeof rawText !== 'string') {
        return [];
    }
    // 标准化换行符
    const normalizedText = rawText.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    // 简单地按换行符分割文本
    const lines = normalizedText.split('\n');
    // 转换为ParagraphData格式并过滤空行
    return lines
        .map((line, index) => ({
        id: `p-${index}`,
        content: line.trim(),
        index: index,
    }))
        .filter(p => p.content.length > 0); // 过滤空行
}
/**
 * 查找文本在哪个段落中
 * @param paragraphs 段落数组
 * @param selectedText 选中的文本
 * @returns 包含选中文本的段落数据，如果未找到则返回null
 */
export function findParagraphContainingText(paragraphs, selectedText) {
    if (!selectedText || !paragraphs || !paragraphs.length) {
        return null;
    }
    // 寻找包含选中文本的段落
    for (const paragraph of paragraphs) {
        if (paragraph.content.includes(selectedText)) {
            return paragraph;
        }
    }
    return null;
}
//# sourceMappingURL=paragraphs.js.map